import Backbone from 'backbone';
import Epoxy from 'backbone.epoxy';

import Config from '../config'

import { diffHash } from './diff';
import { requestBegins, requestEnds } from '../loader';
import { promisify } from '../utils/promisify'; 
import { eq, keyset } from '../utils/arrays';

// todo: correct promise support
// todo: support jsonp
// todo: move into backbone.js
// todo: message as {}, not []
// todo: support { exception_message }
const ajax = Backbone.ajax;
Backbone.ajax = options => {
    const error = options.error || (() => {}),
        success = options.success || (() => {});
        
    options.error = failed;
    options.success = resp => {
        return '0' === resp.res || 0 === resp.res
            ? failed( xhr, '', resp.resText )
            : successful( resp );
    };

    options.headers = options.headers || {}; 
    options.headers['Accept-Language'] = Config.locale();
    
    const promise = Backbone.$.Deferred(),
        xhr = ajax.call( Backbone.$, options );

    if (!options.noLoader)
        requestBegins();

    if (!options.noLoader)
        promise.always( requestEnds );

    return promise;

    function successful(resp) {
        const result = success( resp );
        promise.resolve( resp );
        return result;
    }
    
    function failed(xhr, textStatus, errorThrown = '') {
        // [text, field]
        const err = Backbone.ajax.parseError( xhr, textStatus, errorThrown );
        const result = error.call( options.context, xhr, textStatus, err );
        promise.rejectWith( options.context, [err] );
        return result;
    }
};

// returns [text, field]
Backbone.ajax.parseError = function(xhr, textStatus, errorThrown = '') {
    if (!xhr.responseJSON || !xhr.responseJSON.translit)
        if (xhr.responseJSON && xhr.responseJSON.error_description) {
            const ed = xhr.responseJSON.error_description;
            if (!~ed.indexOf( ':' ))
                return [ed];

            const index = ed.indexOf( ':' );
            return [ed.substr( index + 1 ).trim(), ed.substr( 0, index )];
        } else
            return [errorThrown];

    const { message, parents, translit } = xhr.responseJSON;
    const prefix = parents
        .reduce( (result, { translit, instance_index }) => 
            [...result, translit, instance_index],
            [] );

    return [message, [...prefix, translit]];
};


let Model; export default Model = Backbone.Epoxy.Model.extend( {
    
    initialize(options = {}) {
		this.endpoint = options.endpoint || this.endpoint;

		Backbone.Model.prototype.initialize.apply( this, arguments );
    },
    
    url() {
        let url = this.endpoint,
            suffix = '';

        if (~url.indexOf( '?' )) {
            suffix = url.substr( url.indexOf( '?' ) );
            url = url.replace( suffix, '' );
        }

        if (this.id)
            url += '/' + this.id;

        url += suffix;
            
		return Config.url( url );
    },

    // make fetch() return promise of [model, response]
    fetch(...args) {
        return Backbone.Epoxy.Model.prototype.fetch.apply( this, args )
            .then( resp => [this, resp] );
    },
    
    parse(data, options) {
        const fn = payload => {

            if (this.renameProperties) 
                Object.keys( this.renameProperties )
                    .forEach( propName => {
                        if (!(propName in payload)) return;

                        const newName = this.renameProperties[propName];
                        payload[newName] = payload[propName];
                        delete payload[propName];
                    } );
                
            if (this.customParser) 
                payload = this.customParser( payload, data );

            return payload;

        };

        const { res, resText, ...attrs } = data;
        if (res !== undefined)
            return fn( this.responseAt ? attrs[this.responseAt] || {} : attrs );

        if (this.responseAt && attrs[this.responseAt])
            return fn( attrs[this.responseAt] );

        return fn( attrs || {} );
    },

    patch(attrs = {}) {
        return promisify( this.save( attrs, { patch: true } ) );
    },

    // Returns the changes (difference) applied to this
    // model comparing it with anotherModel.
    // Changes are returned as array [{attrName, newValue: attrValue}]. 
    diff(another/*, options = {}*/) {
        const sameItem = (a, b) => a instanceof Array && b instanceof Array
            ? eq( a, b ) 
            : a === b;

        const attrs = another instanceof Model ? another.toJSON() : another,
            thisAttrs = this.toJSON();

        return keyset( attrs, thisAttrs )
            .map( attrName => [thisAttrs[attrName], attrs[attrName], attrName] )
            .filter( ([newValue, oldValue]) => !sameItem( newValue, oldValue ) )
            .map( ([newValue, oldValue, attrName]) => ({ attrName, newValue, oldValue, }) );
    },

}, {

    byId(id) {
        const Class = this,
            model = new Class( { id: +id } );

        return promisify( model.fetch() )
            // Backbone bug? changedAttributes() says that attributes
            // got from server by fetch() are "new".
            // So, let's set them explicitly.
            .then( () => model.set( model.toJSON() ) );
    },

} );


// WEBPACK FOOTER //
// ./src/js/model/model.js